module.exports = __webpack_public_path__ + "img/Bild 4.cb4e88a9.jpg";